


































import { Component, Vue } from 'vue-property-decorator';
import { PropertiesApi } from '../api/properties';
import PropSettings from 'modules/common/components/PropSettings.vue';
import appMessage from 'modules/core/models/appMessage';
import { ContactProperty } from 'modules/installation-wizard/classes/contactProperty';
import PropertyOriginSelector from './PropertyOriginSelector.vue';

@Component({
  components: {
    PropSettings,
    PropertyOriginSelector,
  },
})
export default class Integration extends Vue {
  public loading: boolean = false;
  public props: ContactProperty[] = [];
  public origins: string[] = []
  public selectedOrigin: string = '';
  private api: PropertiesApi;

  constructor() {
    super();
    this.api = new PropertiesApi();
  }

  public async created() {
    this.loading = true;
    const data = await this.api.getProps();
    if (data && data.length > 0) {
      data.forEach((elem: ContactProperty) => {
        if (elem.propertyId === 'cname') {
          elem.fixed = true;
        } else {
          elem.fixed = false;
        }
      });
      this.origins = data
        ?.map((n) => n.origin)
        .filter((item, i, ar) => ar.indexOf(item) === i);
      this.props = data ? data : [];
    }
    this.loading = false;
  }
  

  public updatePropsData(data: ContactProperty[]) {
    this.props = data;
  }

  public updateSelectedOrigin(selectedOrigin: string){
    this.selectedOrigin = selectedOrigin;
  }
  public async saveProps() {
    try {
      this.loading = true;
      await this.api.updateProps(this.props);
      this.loading = false;
      appMessage.show(this.$t('properties.propsUpdatedSuccess'), 'success');
    } catch (error) {
      this.loading = false;
      appMessage.show(this.$t('properties.propsUpdatedError'), 'error');
    }
  }
}
